import(/* webpackMode: "eager" */ "/opt/build/repo/app/quiz/page.tsx")